import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import AllCampaigns from './pages/AllCampaigns';
import CampaignDetails from './pages/CampaignDetails';
import Prizes from './pages/AllPrizes';
import Winners from './pages/Winners';
import Login from './Views/Login';
import MyAccount from './Views/MyAccount';
import Wallet from './pages/Wallet';
import Packages from './Views/Packages';
import ContactUs from './pages/ContactUs';
import Faqs from './pages/Faqs';
import PrivacyPolicy from './Policies/PrivacyPolicy';
import TermsAndConditions from './Policies/TermsAndConditiond';
import PrivateRoute from './PrivateRoute';
import ScrollToTop from './Views/ScrollToTop';
import CategoryCampaigns from './pages/CategoryCampaigns';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>

        {/* PUBLIC ROUTE */}
        <Route path="/" element={<Login />} />

        {/* PRIVATE ROUTES */}
        <Route path="/home" element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        } />

        <Route path="/campaigns" element={
          <PrivateRoute>
            <AllCampaigns />
          </PrivateRoute>
        } />

        <Route path="/campaigns/:id" element={
          <PrivateRoute>
            <CampaignDetails />
          </PrivateRoute>
        } />

        <Route path="/categorycampaigns/:categoryId" element={
          <PrivateRoute>
            <CategoryCampaigns />
          </PrivateRoute>
        } />

        <Route path="/prizes" element={
          <PrivateRoute>
            <Prizes />
          </PrivateRoute>
        } />

        <Route path="/winners" element={
          <PrivateRoute>
            <Winners />
          </PrivateRoute>
        } />

        <Route path="/myaccount" element={
          <PrivateRoute>
            <MyAccount />
          </PrivateRoute>
        } />

        <Route path="/wallet" element={
          <PrivateRoute>
            <Wallet />
          </PrivateRoute>
        } />

        <Route path="/packages" element={
          <PrivateRoute>
            <Packages />
          </PrivateRoute>
        } />

        {/* PUBLIC ROUTES */}
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />

      </Routes>
    </>
  );
}

export default App;